export const LOAD_TROUBLESHOOT_ASSET = "LOAD_TROUBLESHOOT_ASSET";
export const LOAD_TROUBLESHOOT_ASSET_SUCCESS =
  "LOAD_TROUBLESHOOT_ASSET_SUCCESS";
export const LOAD_TROUBLESHOOT_ASSET_ERROR = "LOAD_TROUBLESHOOT_ASSET_ERROR";
